import styled from '@emotion/styled'

export const Container = styled.div<{
  isdark: boolean
}>`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  max-width: 250px;

  &:hover .card {
    border: ${(props) =>
      props.isdark ? '2px solid #2FBDF4' : '2px solid #00DFCE'};
    box-shadow: ${(props) =>
      props.isdark ? '0px 0px 30px 0px #2FBDF4' : '0px 0px 30px 0px #0F68AA'};
  }

  &:hover .mycard {
    border: ${(props) =>
      props.isdark ? '2px solid #2FBDF4' : '2px solid #00DFCE'};
    box-shadow: ${(props) =>
      props.isdark ? '0px 0px 30px 0px #2FBDF4' : '0px 0px 30px 0px #0F68AA'};
  }

  &:hover .arrowStyle {
    opacity: 1;
  }

  @media (max-width: 768px) {
    margin-left: 15%;
  }
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ArrowStyle = styled.img`
  cursor: pointer;
  opacity: 0;
`

export const Card = styled.div`
  height: 300px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 16px;
  text-align: center;
  cursor: pointer;
  backdrop-filter: blur(50px);
  justify-content: space-between;
  border: 2px solid transparent;
  z-index: 2;
  position: relative;

  .ant-progress-text {
    color: white;
    display: flex;
    justify-content: center;
  }
`

export const MyCard = styled.div`
  width: 85%;
  height: 100px;
  margin-bottom: 2rem;
  position: relative;
  top: -15px;
  left: 8%;
  align-items: center;
  padding: 20px 10px 10px 10px;
  border-radius: 16px;
  cursor: pointer;
  opacity: 0.9;
  backdrop-filter: blur(50px);
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  z-index: 1;

  .ant-progress-text {
    color: white;
    display: flex;
    justify-content: center;
  }
`

export const Icon = styled.img`
  width: 36px;
  border-radius: 8px;
`

export const IconContainer = styled.div`
  background-color: #ddd;
  width: 36px;
  height: 36px;
  display: inline-block;
  border-radius: 8px;
  margin-right: 0.5rem;
`

export const PosName = styled.span`
  margin-left: 5px;
  font-size: 14px;
`

export const BottomArea = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`

export const HeartPercent = styled.div`
  display: flex;
  flex-direction: column;
`

export const Percent = styled.span`
  display: inline-block;
  font-size: 22px;
  font-weight: 600;
  color: #0f68aa;
  top: 18%;
  width: 100%;
`

export const FeeRate = styled.div`
  display: flex;
  flex-direction: column;
`

export const TextIcon = styled.span`
  color: #818d96;
  font-size: 12px;
  position: relative;
  top: -5px;
`

export const CardContentCon = styled.div`
  display: flex;
  flex-direction: column;
`

export const StakeData1 = styled.div`
  font-size: 22px;
  line-height: 24px;
  font-family: Inter-Black, Inter;
  margin-top: 3px;
`

export const StakeData2 = styled.div`
  font-size: 12px;
  line-height: 12px;
  color: #bfbfbf;
  margin-top: 3px;
`

export const CardPart1 = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
`

export const CardPart2 = styled.div`
  text-align: center;
`

export const Data = styled.div`
  display: flex;
  justify-content: space-between;
  color: #757575;
  font-size: 12px;
  font-weight: 500;
  width: 100%;
`
